import Vue from 'vue'

// Screen size
Vue.prototype.$screen = Vue.observable({
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: false,
    isTablet: false,
    isLaptop: false,
    isDesktop: false,
    isWidescreen: false,
});
function viewportType() {
    var width = window.innerWidth;
    var screen = Vue.prototype.$screen;
    screen.isWidescreen = width > 1200 ? true : false;
    screen.isDesktop = width > 1024 ? true : false;
    screen.isLaptop = width > 840 && width <= 1024 ? true : false;
    screen.isTablet = width > 640 && width <= 840 ? true : false;
    screen.isMobile = width <= 640 ? true : false;
}
document.addEventListener('DOMContentLoaded', viewportType);
viewportType();
window.addEventListener('resize', () => {
    Vue.prototype.$screen.width = window.innerWidth;
    Vue.prototype.$screen.height = window.innerHeight;
    viewportType();
});
